import BaseApi from './BaseApi';

/**
 * サーバー時間を取得するAPI。
 */
class GetEnableDeviceTimeApi extends BaseApi {
  async get(clientTime: string): Promise<boolean> {
    return await this.execute('getEnableDeviceTimeApi', {
      method: 'POST',
      body: { clientTime }
    }).then(({ result }) => result);
  }
}

export default GetEnableDeviceTimeApi;
